<template>
    <div class="mt-[28px]">
        <div class="text-white font-semibold text-[16px] mb-[12px] text-center">
            Підпапки
        </div>

        <div
            v-for="sub in subfolders"
            :key="sub.id"
            class="relative w-[60%] mt-[12px] mx-auto"
        >
            <div
                v-if="renamingId !== sub.id"
                class="bg-[#BD9135] flex justify-center items-center h-[38px] cursor-pointer text-white font-semibold py-[5px] rounded-lg"
                @click="$emit('select', sub.name)"
            >
                <span class="text-black">{{ sub.name }}</span>
            </div>
            <div
                v-else
                class="bg-[#BD9135] flex justify-center items-center gap-2 h-[38px] px-3 rounded-lg"
                @click.stop
            >
                <input
                    v-model="renameValue"
                    class="flex-1 bg-white text-black rounded px-2 py-1 outline-none text-sm"
                    @keyup.enter="submitRename(sub)"
                />
                <button type="button" class="bg-black text-white text-xs px-2 py-1 rounded" @click="submitRename(sub)">OK</button>
                <button type="button" class="bg-white/70 text-black text-xs px-2 py-1 rounded" @click="cancelRename">×</button>
            </div>

            <div
                v-if="editable && canEdit && renamingId !== sub.id"
                class="absolute right-[-48px] top-1/2 -translate-y-1/2 flex gap-1"
            >
                <button
                    type="button"
                    class="bg-[#474849] rounded p-1 hover:bg-[#5a5b5c]"
                    title="Перейменувати"
                    @click.stop="startRename(sub)"
                >
                    <img src="@/assets/icons/pen_icon.svg" class="w-4 h-4" />
                </button>
                <button
                    type="button"
                    class="bg-[#474849] rounded p-1 hover:bg-[#5a5b5c]"
                    title="Видалити"
                    @click.stop="confirmDelete(sub)"
                >
                    <img src="@/assets/icons/trash_icon.svg" class="w-4 h-4" />
                </button>
            </div>
        </div>

        <div v-if="editable && canEdit" class="w-[60%] mt-[16px] mx-auto">
            <div
                v-if="!showAddForm"
                class="border border-dashed border-[#BD9135] flex justify-center items-center h-[38px] cursor-pointer text-[#BD9135] font-semibold rounded-lg"
                @click="showAddForm = true"
            >
                + Додати підпапку
            </div>
            <div v-else class="flex gap-2 items-center">
                <input
                    v-model="newName"
                    class="flex-1 bg-transparent border border-[#BD9135] text-white rounded px-2 py-1 outline-none placeholder:text-white/50"
                    placeholder="Назва підпапки"
                    @keyup.enter="submitAdd"
                />
                <button type="button" class="bg-[#BD9135] text-black text-sm font-semibold px-3 py-1 rounded" @click="submitAdd">Додати</button>
                <button type="button" class="bg-[#474849] text-white text-sm px-3 py-1 rounded" @click="cancelAdd">Скасувати</button>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, computed, watch } from 'vue'
import { uuid } from 'vue3-uuid'
import {
    addTrainingElementSubfolder,
    updateTrainingElementSubfolderById,
    deleteTrainingElementSubfolderById
} from '@/services/apiRequests'

export default {
    name: 'FolderSubfoldersPanel',

    props: {
        folderId: {
            type: String,
            required: true
        },
        subfolders: {
            type: Array,
            default: () => []
        },
        editable: {
            type: Boolean,
            default: true
        }
    },

    emits: ['select', 'changed'],

    setup(props, { emit }) {
        const showAddForm = ref(false)
        const newName = ref('')
        const renamingId = ref(null)
        const renameValue = ref('')

        const canEdit = computed(() => localStorage.getItem('userType') !== 'supervisor')

        const cancelAdd = () => {
            showAddForm.value = false
            newName.value = ''
        }

        const cancelRename = () => {
            renamingId.value = null
            renameValue.value = ''
        }

        const startRename = (sub) => {
            renamingId.value = sub.id
            renameValue.value = sub.name
        }

        const submitAdd = async () => {
            const name = newName.value.trim()
            if (!name || !props.folderId) return
            await addTrainingElementSubfolder(name, props.folderId, uuid.v4())
            cancelAdd()
            emit('changed')
        }

        const submitRename = async (sub) => {
            const name = renameValue.value.trim()
            if (!name) return
            await updateTrainingElementSubfolderById(sub.id, name)
            cancelRename()
            emit('changed')
        }

        const confirmDelete = async (sub) => {
            if (!confirm(`Видалити підпапку «${sub.name}»?`)) return
            await deleteTrainingElementSubfolderById(sub.id)
            emit('changed')
        }

        watch(() => props.folderId, () => {
            cancelAdd()
            cancelRename()
        })

        return {
            showAddForm,
            newName,
            renamingId,
            renameValue,
            canEdit,
            cancelAdd,
            startRename,
            cancelRename,
            submitAdd,
            submitRename,
            confirmDelete
        }
    }
}
</script>
